import { SegmentedControlProps } from "./types";
import { SegmentedControl } from "./segmentedControl";
import { SegmentedControlTab } from "./segmentedControlTab";

export { SegmentedControlProps, SegmentedControl, SegmentedControlTab };
export default SegmentedControl;
